import React from "react";

export default function CaretDown(props: any) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.2635 6.26346L8.26346 11.2635C8.19315 11.3337 8.09783 11.3731 7.99846 11.3731C7.89908 11.3731 7.80377 11.3337 7.73346 11.2635L2.73346 6.26346C2.66722 6.19237 2.63116 6.09835 2.63287 6.0012C2.63459 5.90405 2.67394 5.81135 2.74265 5.74265C2.81135 5.67394 2.90405 5.63459 3.0012 5.63287C3.09835 5.63116 3.19237 5.66722 3.26346 5.73346L7.99846 10.4678L12.7335 5.73346C12.8045 5.66722 12.8986 5.63116 12.9957 5.63287C13.0929 5.63459 13.1856 5.67394 13.2543 5.74265C13.323 5.81135 13.3623 5.90405 13.364 6.0012C13.3658 6.09835 13.3297 6.19237 13.2635 6.26346Z"
        fill="#262626"
      />
    </svg>
  );
}
